export default "__VITE_ASSET__DaYWdHNL__"